<template>
  <div
    class="container lms-wrapper no-right-sidebar pd-x-0 pd-lg-x-10 pd-xl-x-0"
  >
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item" v-for="(type, i) in types" :key="'tt' + i">
            <!-- {{$route.name}} -->
            <router-link
              :to="{ name: $route.name, params: { cid: type.id } }"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.cid == type.id ? 'active' : ''
                }`
              "
              >{{ type.s1 }}</router-link
            >
          </li>
        </ul>

        <div class="row">
          <div class="col-lg-8 col-xl-9">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <div class="row row-sm mg-b-25">
                <template v-if="tasks.length > 0">
                  <div
                    v-for="(task, i) in tasks"
                    :key="'tsk_' + i"
                    class="col-md-6"
                  >
                    <div class="card card-event" @click="taskDetail(task.id)">
                      <img
                        :src="`${task.defaultAttachmentUrl}?w=480`"
                        class="card-img-top"
                        alt
                      />
                      <div class="card-body tx-13">
                        <h5>
                          <span>{{ task.task }}</span>
                        </h5>
                        <!-- <p class="mg-b-0">Mar 22 - Mar 24, World Trade Center Metro</p>
                        <span class="tx-12 tx-color-03">Manila, Philippines</span>-->
                      </div>
                      <div class="card-footer tx-13">
                        <!-- <span class="tx-color-03">6,187 people interested</span> -->
                        <button class="btn btn-xs btn-secondary">
                          дэлгэрэнгүй
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="wd-100p">
                    <ul class="list-group list-group-flush tx-13">
                      <li class="list-group-item d-flex pd-sm-x-20">
                        <div
                          class="container d-flex justify-content-center ht-100p"
                        >
                          <div
                            class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                          >
                            <div class="wd-80p wd-sm-300 mg-b-15">
                              <img
                                src="assets/svg/boxempty.svg"
                                alt
                                class="img-fluid"
                              />
                            </div>
                            <h4 class="tx-18 text-muted">
                              Мэдээлэл хоосон байна.
                            </h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </template>
              </div>
            </vue-custom-scrollbar>
          </div>
          <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.right}px; position: relative;`"
            >
              <!-- <div class="d-flex align-items-center justify-content-between mg-b-20">
                <h6 class="tx-uppercase tx-semibold mg-b-0">Удахгүй болох</h6>
              </div>
              <ul class="list-unstyled media-list mg-b-15">
                <li class="media align-items-center">
                  <div
                    class="wd-40 ht-40 bg-dark tx-white d-flex align-items-center justify-content-center rounded"
                  >
                    <feather type="calendar" class="ht-25-f wd-25-f"></feather>
                  </div>
                  <div class="media-body pd-l-15">
                    <h6 class="mg-b-2">
                      <a href class="link-01">Үйл явдал</a>
                    </h6>
                    <span class="tx-13 tx-color-03">Today, April 21, 5:00pm</span>
                  </div>
                </li>
              </ul>-->

              <h6 class="tx-uppercase tx-semibold mg-b-15">Ангилал</h6>

              <nav class="nav nav-classic tx-13">
                <router-link
                  :to="{ name: $route.name, params: { cid: type.id } }"
                  :class="
                    `nav-link ${$route.params.cid == type.id ? 'active' : ''}`
                  "
                  v-for="(type, i) in types"
                  :key="'st' + i"
                >
                  <span>{{ type.s1 }}</span>
                  <!-- {{type.id}} -->
                  <!-- <span class="badge">20</span> -->
                </router-link>
              </nav>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modal.show"
      hide-footer
      :title="modal.data.task"
      centered
      body-class="pd-0"
      size="lg"
      scrollable
    >
      <!-- <div class="modal-header">
        <h6 class="modal-title" id="exampleModalLabel3">Modal Title</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>-->
      <div class="modal-body">
        <div class="card card-profile card-event">
          <img
            :src="modal.data.defaultAttachmentUrl"
            alt
            class="card-img-top"
            style="height: 350px"
          />
          <div class="card-body tx-13 pd-y-10-f">
            <div class="avatar wd-140 ht-140 mt-n80px pos-relative">
              <img
                :src="`${groupLogo}?w=144&h=144&mode=crop`"
                alt
                class="rounded-circle img-thumbnail border-0 pd-0-f"
              />
            </div>
            <div class="ht-50 align-items-start mg-l-150 pd-l-10">
              <div class="d-flex align-items-center wd-100p">
                <div>
                  <h6>
                    <a>{{ modal.data.task }}</a>
                  </h6>
                  <!-- <p class="mg-b-0">{{modal.data.dueStartDate | moment('YYYY.MM.DD')}} - {{modal.data.dueDate | moment('YYYY.MM.DD')}}</p> -->
                </div>
                <!-- <div class="mg-l-auto">                    
                    <button v-if="modal.data.im == null" class="btn btn-xs btn-uppercase btn-primary">Оролцох</button>
                    <template v-else>
                      <span class="badge badge-success">Та оролцож байна.</span>
                    </template>
                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="divider-text">Дэлгэрэнгүй</div>

        <div v-html="modal.data.taskDesc"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      nowDate: null,
      types: [],
      tasks: [],
      allCount: 0,
      typeKey: "typenews",
      ot: 73,
      groupLogo: "",
      modal: {
        id: 0,
        show: false,
        data: {}
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    let _companyLogo = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    init() {
      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: this.typeKey,
          getParentType: false
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
        }
      });

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 200,
          ot: this.ot,
          model: {
            isPublic: true,
            //isTender: false,
            locTypeId:
              this.$route.params.cid > 0 ? this.$route.params.cid : null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetCoreList', res);
          this.allCount = res.data.allCount;
          this.nowDate = res.data.nowDate;
          this.tasks = res.data.tasks;
        }
      });
    },
    taskDetail(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.id = id;
          this.modal.data = res.data.task;
          this.modal.show = true;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>
